import "./Stores.css"
import { FaQrcode, FaUsers, FaGift } from "react-icons/fa";
import { TbFileCertificate } from "react-icons/tb";
import { PiShareNetworkFill } from "react-icons/pi";
import { FaMobileAlt, FaTachometerAlt, FaBell, FaClipboardList } from "react-icons/fa";
import ResponsiveContainer from "../../../responsive/components/ResponsiveContainer/ResponsiveContainer";

const Stores = () => {
    const retailFeatures = [
        {
            title: "Instant Product Scanning",
            desc: "Show customers real-time authenticity verification right at the point of sale",
            icon: <FaQrcode />,
        },
        {
            title: "Digital Certificates",
            desc: "Provide customers with downloadable authenticity certificates for their purchases",
            icon: <TbFileCertificate />,
        },
        {
            title: "Customer Confidence",
            desc: "Build reputation as the most trustworthy retailer in your area",
            icon: <FaUsers />,
        },
        {
            title: "Loyalty Integration",
            desc: "Reward verified purchases by linking authenticity checks with customer loyalty programs",
            icon: <FaGift />, // Gift/loyalty rewards
        },
    ];

    const inventoryFeatures = [
        {
            title: "Mobile Scanning",
            desc: "Quick verification with your smartphone - scan products as they arrive",
            icon: <FaMobileAlt />,
        },
        {
            title: "Real-time Dashboard",
            desc: "Monitor your entire inventory status from one simple dashboard",
            icon: <FaTachometerAlt />,
        },
        {
            title: "Automated Alerts",
            desc: "Get notified immediately if any products fail verification",
            icon: <FaBell />,
        }
    ];

    return (
        <ResponsiveContainer>
            <div className="stores-page ">
                <div className="stores-header">
                    <h1 className="stores-title">For Stores</h1>
                </div>

                <section className="stores-section offer-authenticity">
                    <h2>Offer Your Customers Proven Authenticity</h2>
                    <p>Give your customers the confidence they deserve. Every product comes with instant verification that proves authenticity, building trust that leads to repeat business and word-of-mouth recommendations.</p>
                    <div className="offer-authenticity-content">
                        <div className="image">

                        </div>
                        <div className="offer-authenticity-features">
                            {retailFeatures.map((feature, index) => (
                                <div key={index} className="feature">
                                    <div className="icon">
                                        {feature.icon}
                                    </div>
                                    <h3>{feature.title}</h3>
                                    <p>{feature.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="stores-section simple-inventory-verification">
                    <h2>Simple Inventory Verification</h2>
                    <p>Streamline your inventory management with automated verification. Know the authenticity status of every product in your store with real-time updates and comprehensive reporting.</p>
                    <div className="features-inventory-verification">
                        {
                            inventoryFeatures.map((feature, index) => (
                                <div key={index} className="feature">
                                    <div className="icon">
                                        {feature.icon}
                                    </div>
                                    <h3>{feature.title}</h3>
                                    <p>{feature.desc}</p>
                                </div>
                            ))
                        }
                    </div>
                </section>

                <section className="stores-section become-trusted-retailer">
                    <h2>Become a Trusted Halal Retailer in Your Community</h2>
                    <div className="image">
                    </div>
                    <p>Build deep trust within your community by offering verified halal products. Become the go-to destination for families seeking authentic, certified halal options with complete confidence.</p>
                    <button className=" btn-icon-primary">
                        <PiShareNetworkFill className="icon" />
                        Join as a Retail Partner
                    </button>
                </section>
            </div>
        </ResponsiveContainer>
    )
}

export default Stores